// extracted by mini-css-extract-plugin
module.exports = {"headerStyle":"_19ach25jqCzpxfz-la6h2m"};